import React from 'react';
import AppRoutes from './routes';
import { AuthProvider, useAuth } from './AuthContext';
import { NotificationProvider } from './NotificationContext';
import PushNotificationPrompt from './components/PushNotificationPrompt';

function App() {
  // Use auth context to determine authentication state
  const { token, loading } = useAuth();
  const isAuthenticated = !!token;

  if (loading) {
    // Optionally render a splash / loading state while auth initializes
    return null;
  }

  return (
    <NotificationProvider>
      <AppRoutes isAuthenticated={isAuthenticated} />
      <PushNotificationPrompt />
    </NotificationProvider>
  );
}

export default function AppWithProviders() {
  return (
    <AuthProvider>
      <App />
    </AuthProvider>
  );
}
